import { GenericGridSmartViewsBaseDataProvider } from './GenericGridSmartViewsBaseDataProvider';
import {
  SmartViewItemConfiguration,
  SmartViewsCreateRequest,
  SmartViewsUpdateRequest,
  StateGetResponse,
} from '../types';
import { ValidateViewNameResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';

export class GenericGridSmartViewsNirvanaDataProvider extends GenericGridSmartViewsBaseDataProvider {
  public async getDataForView(): Promise<Array<SmartViewItemConfiguration>> {
    return this.readViews(this.dependencies.componentName);
  }

  public async addCustomView(
    componentName: string,
    details: SmartViewsCreateRequest
  ): Promise<SmartViewItemConfiguration> {
    return this.dependencies.api.clients.SmartViews.addCustomView(
      componentName,
      { details: { ...details } }
    ).toPromise();
  }

  public async updateCustomView(componentName: string,
    updatedView: SmartViewsUpdateRequest
  ): Promise<SmartViewItemConfiguration> {
    return this.dependencies.api.clients.SmartViews.updateCustomView(
      componentName,
      { id: updatedView.id, details: updatedView.details }
    ).toPromise();
  }

  public async deleteCustomView(componentName: string, id: string): Promise<any> {
    return this.dependencies.api.clients.SmartViews.deleteCustomView(componentName, { id }).toPromise();
  }

  public async addRecentView(componentName: string, details: SmartViewsCreateRequest): Promise<any> {
    return this.dependencies.api.clients.SmartViews.addRecentView(
      componentName,
      { details: { ...details } }
    ).toPromise();
  }

  public async updateRecentView(componentName: string, id: string, details: SmartViewsUpdateRequest): Promise<any> {
    return this.dependencies.api.clients.SmartViews.updateRecentView(componentName, { id, details }).toPromise();
  }

  public async addToFavorite(componentName: string, id: string): Promise<any> {
    return this.dependencies.api.clients.SmartViews.addToFavorite(componentName, { id }).toPromise();
  }

  public async removeFromFavorite(componentName: string, id: string): Promise<any> {
    return this.dependencies.api.clients.SmartViews.removeFromFavorite(componentName, { id }).toPromise();
  }

  public async readViews(componentName: string): Promise<Array<SmartViewItemConfiguration>> {
    return this.dependencies.api.clients.SmartViews.readViews(componentName).toPromise();
  }

  public async validateViewName(componentName: string, name: string): Promise<ValidateViewNameResponse> {
    return this.dependencies.api.clients.SmartViews.validateViewName(componentName, { name }).toPromise();
  }

  public async getSmartViewSettings(name: string): Promise<StateGetResponse> {
    return this.dependencies.api.clients.State.getStateByName({ name }).toPromise();
  }

  public async upsertState(records: Array<any>): Promise<Array<StateGetResponse>> {
    return this.dependencies.api.clients.State.upsertRecords({ records }).toPromise();
  }
}
